import { motion } from "framer-motion";
import { MessageCircle, Send, ArrowUpRight } from "lucide-react";

const channels = [
    {
        name: "WHATSAPP",
        tagline: "Hubungi Sekarang",
        detail: "+855 96 4453 740",
        description: "Jalur tercepat untuk bantuan PUSATCUAN. Tim kami membalas dalam hitungan menit, 24 jam nonstop.",
        url: "https://wa.me/855964453740",
        icon: MessageCircle,
        testid: "whatsapp-cta-card",
        linkTestid: "whatsapp-cta-button",
        accent: {
            border: "border-[#25D366]/25 hover:border-[#25D366]/70",
            ring: "focus:ring-[#25D366]",
            icon: "text-[#25D366]",
            tagline: "text-[#25D366]",
            detail: "text-[#7ff0b0]",
            glow: "bg-[#25D366]/10",
            pill: "border-[#25D366]/40 text-[#7ff0b0] group-hover:border-[#25D366] group-hover:bg-[#25D366]/10",
            arrow: "group-hover:text-[#7ff0b0]",
        },
    },
    {
        name: "TELEGRAM",
        tagline: "Pesan Alternatif",
        detail: "@tpusatcuan",
        description: "PUSATCUAN Telegram resmi untuk chat langsung dengan admin. Nyaman, ringan, dan selalu aktif.",
        url: "https://t.me/tpusatcuan",
        icon: Send,
        testid: "telegram-cta-card",
        linkTestid: "telegram-cta-button",
        accent: {
            border: "border-[#2AABEE]/25 hover:border-[#2AABEE]/70",
            ring: "focus:ring-[#2AABEE]",
            icon: "text-[#2AABEE]",
            tagline: "text-[#2AABEE]",
            detail: "text-[#8fd4f7]",
            glow: "bg-[#2AABEE]/10",
            pill: "border-[#2AABEE]/40 text-[#8fd4f7] group-hover:border-[#2AABEE] group-hover:bg-[#2AABEE]/10",
            arrow: "group-hover:text-[#8fd4f7]",
        },
    },
];

export const CTASection = () => (
    <section
        id="kontak"
        data-testid="cta-section"
        className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32"
    >
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {channels.map((ch, i) => (
                <motion.div
                    key={ch.name}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                >
                    <a
                        href={ch.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={ch.linkTestid}
                        className={`cta-card group relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border bg-gradient-to-b from-[#111111] to-[#0A0A0A] p-8 focus:outline-none focus:ring-1 sm:p-12 ${ch.accent.border} ${ch.accent.ring}`}
                    >
                        <div
                            aria-hidden="true"
                            className={`absolute -right-16 -top-16 h-48 w-48 rounded-full blur-3xl transition-opacity duration-500 group-hover:opacity-100 ${ch.accent.glow}`}
                        />
                        <div data-testid={ch.testid}>
                            <div className="mb-10 flex items-center justify-between">
                                <ch.icon
                                    className={`h-10 w-10 transition-transform duration-500 group-hover:scale-110 ${ch.accent.icon}`}
                                    strokeWidth={1.5}
                                />
                                <ArrowUpRight className={`h-6 w-6 text-[#A1A1AA] transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 ${ch.accent.arrow}`} />
                            </div>
                            <h3 className="font-serif-display text-3xl font-semibold tracking-wide text-white sm:text-4xl">
                                {ch.name}
                            </h3>
                            <p className={`mt-1 text-sm italic ${ch.accent.tagline}`}>{ch.tagline}</p>
                            <p className={`mt-6 font-mono text-lg tracking-wider ${ch.accent.detail}`}>
                                {ch.detail}
                            </p>
                            <p className="mt-4 text-sm leading-relaxed text-[#A1A1AA]">
                                {ch.description}
                            </p>
                        </div>
                        <span className={`mt-10 inline-flex w-fit items-center gap-2 rounded-full border px-5 py-2.5 text-xs font-semibold tracking-[0.18em] uppercase transition-colors duration-300 ${ch.accent.pill}`}>
                            Mulai Chat
                        </span>
                    </a>
                </motion.div>
            ))}
        </div>
    </section>
);
